import { SortingDirection } from '../tabs/Positions/components/AlternativeDetail/AlternativeDetail.meta';

export const compareValueStrings = (a, b, sortingDirection) => {
  if (a === '–') {
    return sortingDirection === SortingDirection.Asc ? -1 : 1;
  }

  if (b === '–') {
    return sortingDirection === SortingDirection.Asc ? 1 : -1;
  }

  const parsedA = parseFloat(a.replace(/[^0-9.-]+/g, ''));
  const parsedB = parseFloat(b.replace(/[^0-9.-]+/g, ''));

  if (Number.isNaN(parsedA) || Number.isNaN(parsedB)) {
    return sortingDirection === SortingDirection.Asc ? a.localeCompare(b) : b.localeCompare(a);
  }

  return sortingDirection === SortingDirection.Asc ? parsedA - parsedB : parsedB - parsedA;
};

export const sortTableRows = (rows, sortingKey, sortingDirection) => {
  const sortedDataRows = rows.map(row => {
    const sortedRows = [...(row.childRows ?? [])].sort((a, b) =>
      compareValueStrings(a.cells[sortingKey].text, b.cells[sortingKey].text, sortingDirection),
    );

    return { ...row, childRows: sortedRows };
  });

  const totalRow = sortedDataRows.pop();

  // Sort groups
  return [
    ...sortedDataRows.sort((a, b) =>
      compareValueStrings(a.cells[sortingKey].text, b.cells[sortingKey].text, sortingDirection),
    ),
    totalRow,
  ];
};
